import { getLanguage } from "CMS/utils";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import { BasicTemplatePill } from "components/Pill/BasicTemplatePill";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SmallDetails from "components/SmallDetails/SmallDetails";
import { NewInvitationTemplateModal } from "invitationTemplate/new/NewInvitationTemplateModal";
import TwoColumnLayout from "layout/TwoColumnLayout";
import moment from "moment";
import React from "react";
import { useLoaderData } from "react-router";
import { routes } from "utilities/routing/generatedRoutes";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { PreferredTemplatePill } from "components/Pill/PreferredTemplatePill";
import { localizedLanguageSort } from "utilities/translationUtils";

const MessageTemplateListApp = () => {
  const [isCreating, setIsCreating] = React.useState(false);

  const viewModel = useLoaderData<server.viewmodel.MessageTemplateListFrontModel>();

  return <>
    <NewInvitationTemplateModal
      title={viewModel.pageTitle}
      isOpen={isCreating}
      onClose={() => setIsCreating(false)}
      type={viewModel.type.value}
      onCreated={(id) => {
        setIsCreating(false);
        window.location.href = routes.messageTemplate_Detail(id).absolute;
      }}
    />
    <TwoColumnLayout>
      <TwoColumnLayout.LeftColumn>
        <ListTemplate
          title={viewModel.pageTitle}
          filterSet={viewModel.type.filterSet}
          defaultFilters={viewModel.defaultFilters}
          initialInstruction={{ ...viewModel.initialInstruction, type: viewModel.type.value }}
          fetchFunction={window.CoreApi.MessageTemplate.Paginated}
          getId={item => item.messageTemplateId}
          onNew={() => setIsCreating(true)}
          layout={{
            type: "table",
            columns: [{
              key: "title",
              size: "1fr",
              header: RESX.GeneralLabels.Title,
              render: item => <SmallDetails
                label={item.title}
                subLabel={`${RESX.GeneralLabels.LastModified} ${moment.utc(item.lastModifiedUtc).fromNow()}`}
                link={routes.messageTemplate_Detail(item.messageTemplateId).absolute}
              />
            }, {
              key: "language",
              size: "auto",
              header: RESX.Language.resxLanguage,
              render: item => <>
                {[...item.implementedLanguages].sort(localizedLanguageSort).map(language => <div key={language}>
                  {getLanguage(language).localizedName}
                </div>)}
              </>
            }, {
              key: "default",
              size: "auto",
              header: "",
              render: item => <>
                {item.preferredTemplate && <PreferredTemplatePill />}
                {item.basicTemplate && <BasicTemplatePill />}
              </>
            }]
          }}
          filters={<>
            <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
          </>}
          functions={{
            mapResponseToFilterValues,
            mapFilterValuesToInstruction: (filterSet, filter, page, perPage) => mapFilterValuesToInstruction(viewModel.type.value, filterSet, filter, page, perPage)
          }}
        />
      </TwoColumnLayout.LeftColumn>
      <RightSideNavigation
        title={desktopNavigation.rightSideNavigation.title}
        menuItems={desktopNavigation.rightSideNavigation.items}
        currentPage={desktopNavigation.currentPage}
      />
    </TwoColumnLayout>
  </>
}

export default MessageTemplateListApp;